import React from 'react';
import bannerBg from '@/asserts/images/banner-bg.png';
import iconCircleFile from '@/asserts/images/icon-circle-file.svg';
import { getSite } from '@/common/constants/platform-constants';
import s from './index.module.less';
import OperationButton from './operation-button';
import { SiteMainButtons } from './methods';

const tags = [
  { text: '低门槛', desc: '低代码能力助力高效易用及可视化的 API 开发测试平台' },
  { text: '高专注', desc: '基于插件提供本地调试、mock、代码和接口生成及离线使用能力，减少切换、异步协同' },
  { text: '可扩展', desc: '提供自定义节点，runtime 与脚本语言，并支持代码生成工具和自定义协议扩展' },
];

const Banner = ({ contentWidth }: { contentWidth: number }) => (
  <div className={s.container}>
    <div className={s.banner} style={{ width: contentWidth }}>
      <div className={s.bg}>
        <img src={bannerBg} alt="" height="100%" />
      </div>
      <div className={s.content}>
        <div className={s.title}>ifBook 面向开发者的智能接口工作台</div>
        <div className={s.desc}>ifBook 是基于设计先行和协议驱动开发理念的 API 全生命周期管理服务平台，助力企业高效实现 API 接口设计、调试、Mock、文档管理和自动化测试。</div>
        <div className={s.btns}>
          {
            SiteMainButtons[getSite()].map((item, index) => (
              <OperationButton
                key={String(index + 1)}
                {...item}
              />
            ))
          }
        </div>
      </div>
    </div>
    <div className={s.tagsWrap}>
      <div className={s.tags} style={{ width: contentWidth }}>
        {
          tags.map(item => (
            <div key={item.text} className={s.tag}>
              <div className={s.text}>
                <img src={iconCircleFile} alt="" />
                {item.text}
              </div>
              <div className={s.desc}>
                {item.desc}
              </div>

            </div>
          ))
        }
      </div>
    </div>
  </div>
);

export default Banner;
